import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class CurrencyService extends HttpService {
	/**
	 * Currency
	 */
	@GET('currency/list')
	@Adapter(null, { isAdmin: true })
	getCurrencies(): Observable<any> {
		return null;
	}

	@POST('currency/create')
	@Adapter(null, { isAdmin: true })
	createCurrency(@Body data: string): Observable<any> {
		return null;
	}
}
